import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';
import Settings from './Settings';
import AccountReducer from './AccountReducer';
import DeliveriesReducer from './DeliveriesReducer';
import ReportReducer from './ReportReducer';

const reducers = combineReducers({
    routing: routerReducer,
    settings: Settings,
    AccountReducer,
    DeliveriesReducer,
    ReportReducer,
});

export default reducers;



// WEBPACK FOOTER //
// ./reducers/index.js